var _path, _path2, _path3, _path4, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgResolvedCommentAdmin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0857 5.03905C11.3855 5.01327 11.6906 5 12 5C12.5523 5 13 4.55228 13 4C13 3.44772 12.5523 3 12 3C11.6334 3 11.2712 3.01572 10.9143 3.0464C6.11969 3.45864 2 6.68117 2 11C2 15.6376 6.7256 19 12 19C12.4321 19 12.8581 18.9782 13.2764 18.9357C13.6757 18.8952 14.0222 19.0104 14.2455 19.2187L15.631 20.511C16.7355 21.5413 18.5398 21.0222 18.928 19.5624L19.8227 16.1976C19.8669 16.0313 19.9673 15.8507 20.1333 15.6654C21.0245 14.671 21.6522 13.4867 21.8924 12.1809C21.9923 11.6377 21.6329 11.1164 21.0897 11.0165C20.5466 10.9166 20.0252 11.276 19.9254 11.8191C19.7597 12.7198 19.3202 13.576 18.6439 14.3307C18.3216 14.6903 18.0337 15.1428 17.8899 15.6836L16.9951 19.0485L15.6097 17.7561C14.8971 17.0915 13.9485 16.8573 13.0746 16.9459C12.7234 16.9816 12.3647 17 12 17C7.33328 17 4 14.0944 4 11C4 8.11264 6.88041 5.40061 11.0857 5.03905Z",
    fill: "#97A0A6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 12C12.5523 12 13 11.5523 13 11C13 10.4477 12.5523 10 12 10C11.4477 10 11 10.4477 11 11C11 11.5523 11.4477 12 12 12Z",
    fill: "#97A0A6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17 11C17 11.5523 16.5523 12 16 12C15.4477 12 15 11.5523 15 11C15 10.4477 15.4477 10 16 10C16.5523 10 17 10.4477 17 11Z",
    fill: "#97A0A6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8 12C8.55229 12 9 11.5523 9 11C9 10.4477 8.55229 10 8 10C7.44772 10 7 10.4477 7 11C7 11.5523 7.44772 12 8 12Z",
    fill: "#97A0A6"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 5,
    r: 4,
    fill: "#0864A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResolvedCommentAdmin);
export default __webpack_public_path__ + "static/media/ResolvedCommentAdmin.c3e9692fca2cdb6f6f56187a5bc08c8c.svg";
export { ForwardRef as ReactComponent };